import {
    Swiper,
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
    // Scrollbar,
  } from 'swiper';
  
  Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);
  
  const navigation = (target) => {
    return {
      nextEl: `.${target}-swiper-button--next`,
      prevEl: `.${target}-swiper-button--prev`,
    };
  };
  
  $(window).on('load', function () {
    swipers();
  });
  
  const swipers = () => {
    imagesSwiper();
    postsSwiper();
    partnerSwiper();
  };

  const partnerSwiper = () => {
    return new Swiper('.module--featured-partner__items', {
      loop: false,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: navigation('module--featured-partner__items__nav'),
      spaceBetween: 30,
      allowTouchMove: false,
      on: {
        init: function () {
          if ($('.module--featured-partner .swiper-button-disabled').length == 2) {
            $('.module--featured-partner .swiper-controls').removeClass('d-flex').addClass('d-none');
          } else {
            $('.module--featured-partner .swiper-controls').removeClass('d-none').addClass('d-flex');
          }
        },
        afterInit: function () {
          $('.module--featured-partner__quote__text').html($('.module--featured-partner__items .swiper-slide-active .module--featured-partner__items__quote').html());
        },
        slideChangeTransitionStart: function () {
          $('.module--featured-partner__quote').css('opacity', 0);
        },
        slideChangeTransitionEnd: function () {
          $('.module--featured-partner__quote__text').html($('.module--featured-partner__items .swiper-slide-active .module--featured-partner__items__quote').html());
          $('.module--featured-partner__quote').css('opacity', 1);
          if ($('.module--featured-partner__items__nav-swiper-button--next').hasClass('swiper-button-disabled')) {
            $('.module--featured-partner__items__nav-swiper-button--prev').addClass('next-disabled');
          } else {
            $('.module--featured-partner__items__nav-swiper-button--prev').removeClass('next-disabled');
          }
        },
      },
    });
  };

  const postsSwiper = () => {
    return new Swiper('.module--posts__swiper', {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 1.1,
      navigation: navigation('module--posts__swiper__nav'),
      breakpoints: {
        992: {
          slidesPerView: 1.7,
        },
      },
      on: {
        init: function () {
          if ($('.module--posts .swiper-button-disabled').length == 2) {
            $('.module--posts .swiper-controls').removeClass('d-flex').addClass('d-none');
          } else {
            $('.module--posts .swiper-controls').removeClass('d-none').addClass('d-flex');
          }
        },
      },
    });
  };
  
  const imagesSwiper = () => {
    return new Swiper('.page-header__inner__swiper', {
      loop: true,
      spaceBetween: 0,
      allowTouchMove: false,
      slidesPerView: 1,
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        reverseDirection: true,
      },
      navigation: navigation('page-header__inner__content__nav'),
      pagination: {
        el: '.page-header__inner__swiper .swiper-progress',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return number;
        },
        formatFractionTotal: function (number) {
          return number;
        },
      },
      on: {
        init: function () {
            $('.page-header__inner__content__pagination .swiper-progress').html($('.page-header__inner__swiper .swiper-progress').html());
        },
        slideChange: function () {
            $('.page-header__inner__content__pagination .swiper-progress').html($('.page-header__inner__swiper .swiper-progress').html());
        },
      },
    });
  };
